@if (segmentItem().url) {
    @if (!hideByZeroCount() || segmentItem().isExactLink || segmentItem().titleParams?.count > 0) {
        <!-- если сегменты ссылочные, то активность сегмента = активности ссылки -->
        <button
            class="bazis-btn-native"
            [attr.disabled]="segmentItem().disabled"
            [routerLink]="segmentItem().url"
            routerLinkActive="bazis-segment__item--selected"
            [routerLinkActiveOptions]="{ exact: segmentItem().isExactLink }"
            part="native"
            #segmentItemLink
        >
            <span
                class="bazis-btn__inner"
                part="inner"
            >
                <slot></slot>
            </span>
        </button>
        <div
            part="indicator"
            class="bazis-segment__indicator"
        >
            <div
                part="indicator-background"
                class="bazis-segment__indicator__bg"
            >
            </div>
        </div>
    }
} @else {
    @if (
        !hideByZeroCount() ||
        segmentItem().id === selectedSegmentItem() ||
        segmentItem().titleParams?.count > 0
    ) {
        <button
            class="bazis-btn-native"
            [attr.disabled]="segmentItem().disabled"
            part="native"
        >
            <span
                class="bazis-btn__inner"
                part="inner"
            >
                <slot></slot>
            </span>
        </button>
        <div
            part="indicator"
            class="bazis-segment__indicator"
        >
            <div
                part="indicator-background"
                class="bazis-segment__indicator__bg"
            >
            </div>
        </div>
    }
}
